export const REVIEW_PLATFORM_TO_DISPLAY = {
  google: "Google",
  yelp: "Yelp",
  facebook: "Facebook",
  tripadvisor: "TripAdvisor",
};
